import React, { useState, useMemo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconAnchorLink } from '@sololearnorg/sol';

import s from './DownloadCertificate.scss';
import { FileFormat } from '../../../../../api/private/global.interface';
import { ICertificate } from '../../../../../api/public/certificates-api';

interface IDownloadCertificateProps {
	certificate: ICertificate;
}

export function DownloadCertificate({
	certificate,
}: IDownloadCertificateProps) {
	useStyles(s);
	const [copied, setCopied] = useState<boolean>(false);

	const generateCertificateUrl = useMemo((): string => certificate?.documents.jpg, [certificate]);

	const copyUrl = (): void => {
		navigator.clipboard.writeText(certificate.url);
		setCopied(true);
	};

	return certificate ? (
		<div
			className="le-download-certificate"
			sl-test-data="cmpDownloadCertificate"
		>
			<div className="le-download-certificate__image">
				<div className="le-download-certificate__image__placeholder" />
				<img src={generateCertificateUrl} alt="certificate" />
			</div>
			<div className="le-download-certificate__url">
				<div className="le-download-certificate__input-container">
					<div className="le-download-certificate__icon">
						<IconAnchorLink />
					</div>
					<div className="le-download-certificate__separator" />
					<input
						className="le-download-certificate__input"
						defaultValue={generateCertificateUrl}
					/>
				</div>
				<button
					onClick={copyUrl}
					type="button"
					className={`le-download-certificate__copy le-download-certificate__copy--${
						copied ? 'copied' : 'not-copied'
					}`}
					sl-test-data="btnCopyCertificateURI"
				>
					{copied ? 'Copied' : 'Copy'}
				</button>
			</div>
			<div
				className="le-download-certificate__footer"
				sl-test-data="cmpLEDownloadCertificateFooter"
			>
				{Object.keys(certificate.documents).map((item, index) => {
					if (
						!(Object.values(FileFormat) as string[]).includes(item)
					) {
						return null;
					}

					return (
						<a
							href={`${certificate.documents[item]}?mode=download`}
							className="le-download-certificate__download"
							key={index}
						>
							Download
							{' '}
							{item.toUpperCase()}
						</a>
					);
				})}
			</div>
		</div>
	) : null;
}
